import React from 'react';
import Raid from '../components/Raid';
import Pageheader from '../utils/headerHelment';

const RaidView = () => {
    return (
        <>
            <Pageheader title="LENS - Raid" />
            <Raid />
        </>
    );
};

export default RaidView;


